import { crudRequest } from '@/services/api';
import { getToDay } from '@/utils/date';

const paramsForm = {
  dateRange: getToDay(),
}
export default {
  namespace: 'maxstock',
  state: {
    dateRange: paramsForm.dateRange,
    defualtDateFormat: 'YYYY-MM-DD 12:00:00',
    scanSite: { name: '萧山分拨中心', code: '5712000' },
    netxtSite: { name: '上海分拨中心', code: '0212000' },
    nextSiteType: '60',
    stockDataList: [],
  },

  effects: {
    *getData(_, { call, put, select }) {
      const { dateRange, scanSite, netxtSite, nextSiteType } = yield select(({ maxstock }) => maxstock)
      const param = {
        centerCode: scanSite?.code,
        centerName: scanSite?.name,
        nextSiteType,
        nextSiteCode: netxtSite?.code,
        nextSiteName: netxtSite?.name,
        beginTime: dateRange[0].format('YYYY-MM-DD HH:mm:ss'),
        endTime: dateRange[1].format('YYYY-MM-DD HH:mm:ss'),
      }
      const data = yield crudRequest(
        '/api/v1/stock/realtime/stockInfo', param,
        { module: 'maxcenterbusi' }
      )
      const stockDataList = data.data || []
      yield put({ type: 'updateState', payload: { stockDataList } })
    }
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
  }
}